module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-7.7093c6a2.png";